import Component from './Component';
import ModalComponent from './ModalComponent';
import AddToCartComponent from './AddToCartComponent';
import TagManagerComponent from './TagManagerComponent';
import GlobalMessageComponent from './GlobalMessageComponent';

export default class AssociatedProductsComponent extends Component {
    get SELECTORS() {
        return {
            html: '.html',
            main: '.js-carousel',
            productReferences: '.js-product-references',
            bundle: '.js-bundle',
            product: '.js-article',
            productReferencesDom: '.product-references-dom',
            productReferencesPopup : 'productReferencesPopup',
            bundleDom: '.bundle-dom',
            bundlePopup : 'bundlePopup',
            openBundleDetails : '.js-open-bundle-details',
            bundlesID: '#bundles',
            carousel: '.product-details__carousel-references',
        }
    }

    get CLASSES() {
        return {
            hide: 'hide'
        }
    }

    get DATA() {
        return {
            CSRFToken: 'data-csrftoken',
            code: 'data-code',
            computed: 'data-computed'
        }
    }

    get TEMPLATES() {
        return {
            productReferencesCarouselTemplate: 'productCarousel--template'
        }
    }

    constructor() {
        super();
        this.ModalComponent = new ModalComponent();
        this.AddToCartComponent = new AddToCartComponent();
        this.TagManagerComponent = new TagManagerComponent();
        this.GlobalMessageComponent = new GlobalMessageComponent();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.DATA.CSRFToken);
    }

    showBundleComponents(bundlesDiv) {
        let carousel = bundlesDiv.querySelector(this.SELECTORS.carousel);
        carousel.classList.toggle(this.CLASSES.hide);
        if (!carousel.classList.contains(this.CLASSES.hide)) {
            bundlesDiv.querySelector(this.SELECTORS.main).setAttribute(this.DATA.computed, 'false');
            this.importComponentCreate('CarouselComponent');
        }
    }

    showProducts(product, isBundle) {
        let url, dom, modal, message;

        if (isBundle) {
            url = this.endpoints.BUNDLE.url,
            dom = document.querySelector(this.SELECTORS.bundleDom),
            modal = document.getElementById(this.SELECTORS.bundlePopup),
            message = 'Al momento non sono presenti bundle.';
        } else {
            url = this.endpoints.PRODUCT_REFERENCES.url,
            dom = document.querySelector(this.SELECTORS.productReferencesDom),
            modal = document.getElementById(this.SELECTORS.productReferencesPopup),
            message = 'Al momento non sono presenti prodotti simili.';
        }

        fetch(url + product.getAttribute(this.DATA.code), {
            method: 'get',
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                if (data.references.length > 0) {
                    let result = {
                        results: Object.values(data.references.flatMap(product=>product.target)),
                        freeTextSearch: isBundle ? 'carousel-bundleCarousel' : 'carousel-productReferencesCarousel'
                    };   
                    this.renderMustache(this.TEMPLATES.productReferencesCarouselTemplate, dom, result);
                    this.TagManagerComponent.dataLayerImpressionsGA4(result, true);
                    this.importComponentCreate('CarouselComponent');
                    this.AddToCartComponent.checkProductsAddedToCartInPage();
                    this.ModalComponent.openModal(modal);  
                } else {
                    this.GlobalMessageComponent.renderGlobalMessages(message, 'warning');
                }
            }
        })
    }

    bindEvents() {
        this.events.on('click', this.SELECTORS.productReferences, (e) => {
            this.showProducts(e.target.closest(this.SELECTORS.product), false);
        });

        this.events.on('click', this.SELECTORS.bundle, (e) => {
            this.showProducts(e.target.closest(this.SELECTORS.product), true);
        });
        
        this.events.on('click', this.SELECTORS.openBundleDetails, (e) => {
            this.showBundleComponents(e.target.closest(this.SELECTORS.bundlesID));
        });
    }

    render() {
        this.log('render Associated Products');
        this.bindEvents();       
    }
}